import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { I18n } from "react-redux-i18n";

import { calculateEstimatedCost } from "../utils/Utils";

import ComponentSelector from "../utils/components/ComponentSelector";
import MapPicker from "../utils/components/MapPicker";
import Comparator from "./Comparator";

import { setAlert } from "../../actions/alertActions";

import "../../styles/components/comparator/Compare.scss";

let cancelToken = null;

class Compare extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      map: false,

      estimateTime: 120,
      selectedEV: null,

      chargers: new Array(3).fill(null),
      selectedCharger: -1,
      tempCharger: null,

      isLoading: false,
    };

    this.fetchChargerDetails = this.fetchChargerDetails.bind(this);
    this.handleOnEstimateTimeChange =
      this.handleOnEstimateTimeChange.bind(this);
    this.handleOnSelectEV = this.handleOnSelectEV.bind(this);
    this.handleOnCompare = this.handleOnCompare.bind(this);
    this.updateChargerPrices = this.updateChargerPrices.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  fetchChargerDetails(charger) {
    const { _id, chargerId, chargerType } = charger;
    axios
      .get("/api/private/connectionstation/chargerDetails", {
        params: {
          _id: chargerId || _id,
          chargerType,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ tempCharger: res.data });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnEstimateTimeChange(e) {
    this.safeSetState({
      estimateTime: e.target.value,
    });
  }

  handleOnSelectEV(e, ev) {
    this.safeSetState(
      {
        selectedEV: ev,
      },
      this.updateChargerPrices
    );
  }

  handleOnCompare(selectedPlug, _idx, groups) {
    this.safeSetState(
      (prevState) => ({
        chargers: [
          ...prevState.chargers.slice(0, this.state.selectedCharger),
          Object.assign({}, this.state.tempCharger, { selectedPlug }),
          ...prevState.chargers.slice(this.state.selectedCharger + 1),
        ],
      }),
      this.updateChargerPrices
    );
  }

  updateChargerPrices() {
    if (cancelToken !== null) cancelToken.cancel("Cancelled. New request made");
    cancelToken = CancelToken.source();
    this.safeSetState({
      isLoading: true,
    });
    this.state.chargers.forEach((charger, idx) => {
      if (charger !== null)
        calculateEstimatedCost(
          this.state.estimateTime,
          charger,
          charger.selectedPlug,
          this.state.selectedEV,
          cancelToken
        ).then((cost) => {
          this.safeSetState((prevState) => ({
            chargers: [
              ...prevState.chargers.slice(0, idx),
              prevState.chargers[idx] !== null
                ? Object.assign({}, prevState.chargers[idx], { cost })
                : null,
              ...prevState.chargers.slice(idx + 1),
            ],
            selectedCharger: null,
            tempCharger: null,
            isLoading: false,
          }));
        });
    });
  }

  closeMap() {
    if (this.state.map === true)
      this.safeSetState({
        map: false,
      });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <div
          id="compare"
          className={
            "evio-container sidebar-fix main-component " +
            (this.state.map ? "half" : "")
          }
          onClick={() => this.closeMap()}
        >
          <ComponentSelector
            tabs={[
              {
                title: "label_comparator",
                component: (
                  <Comparator
                    chargers={this.state.chargers}
                    selectedEV={this.state.selectedEV}
                    tempCharger={this.state.tempCharger}
                    estimateTime={this.state.estimateTime}
                    updateChargerPrices={this.updateChargerPrices}
                    onEstimateTimeChange={this.handleOnEstimateTimeChange}
                    onSelectEV={this.handleOnSelectEV}
                    onSelectCharger={(selectedCharger) =>
                      this.safeSetState({ selectedCharger, map: false })
                    }
                    onPickCharger={this.fetchChargerDetails}
                    onPickFromMap={() => this.safeSetState({ map: true })}
                    onCompare={this.handleOnCompare}
                    isLoading={this.state.isLoading}
                  />
                ),
              },
            ]}
          />
        </div>
        {this.state.map && (
          <MapPicker
            onPick={(charger) => {
              this.safeSetState({ map: false }, () =>
                this.fetchChargerDetails(charger)
              );
            }}
          />
        )}
      </>
    );
  }
}

export default connect(null, { setAlert })(Compare);
